module.exports = __webpack_public_path__ + "img/Seite26-default.ad5c3b3e.png";